module.exports = __webpack_public_path__ + "img/sticky-bg-euro.3223128.svg";